import { render, staticRenderFns } from "./OptionPropertyInstructionsYN.vue?vue&type=template&id=2cb79e02"
import script from "./OptionPropertyInstructionsYN.vue?vue&type=script&lang=js"
export * from "./OptionPropertyInstructionsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports